<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">RelatedLinks</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/relatedLinks/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control" v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod" @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>
    </main>
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/RelatedLinks/MenuList.vue";
import lang from "@/views/modules/RelatedLinks/language/en";
import GenericList from "@/components/layout/shared/generic/ListView.vue";
import CustomList from "@/views/modules/RelatedLinks/ListView.vue";
import CustomSearch from "@/views/modules/RelatedLinks/SearchView.vue";
    export default {
        name: "new-categorys",
        components: {
            breadcrumbs,
            GenericList,
            CustomList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive:false,
                metaList: [
                    {
                        label: lang.LBL_CREATED_BY,
                        link: true,
                        moduleName: 'RelatedLinks',
                        routePath: 'relatedLinks',
                        linkOtherModule:false
                    
                    },
                    {
                        label: lang.LBL_PARENT_TYPE,
                        link: true,
                        linkOtherModule:false
                    },
                    {
                        label: lang.LBL_PARENT_ID,
                        link: false,
                        linkOtherModule:false
                    },
                    {
                        label: lang.LBL_CREATE_DATE,
                        link: false,
                        linkOtherModule:false
                    },
                    {
                        label: lang.LBL_DESCRIPTION,
                        link: false,
                        linkOtherModule:false
                    },
                ],
                columns: ['created_by', 'parent_type', 'parent_id', 'date_entered', 'description'],
            }
        },
        mounted() {
            this.childMethod();
            this.$emit('MetaView', 'Awesome')
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns);
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>